import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SalaryAndAdvantage } from "@services/all.services";
import { useNotification } from "@hooks/useNotification";
import ModalDelete from "@components/modals/modalDelete";

const ModalDeleteSalary = ({
  onClickClose,
  isOpen,
  toggle,
  salaryId
}) => {
  const { t: translator } = useTranslation("pages.employés.parcours&Certifications");
  const { showError, showSuccess } = useNotification();

  const [isLoading, setIsLoading] = useState(false);
  function onDeleteClicked() {
    setIsLoading(true);
    SalaryAndAdvantage.deleteById(salaryId)
      .then((response) => {
        setIsLoading(false);
        // if(!response.data.success){
        //   showError(response.data.message)
        // }else{
          showSuccess("delete_action_success", { object: "salary" });
          onClickClose();
        //}
      })
      .catch((err) => {
        console.log(err);
        showError("error");
        setIsLoading(false);
      });
  }

  return (
    <ModalDelete
      isOpen={isOpen}
      toggle={toggle}
      content={translator("Êtes-vous sûr de vouloir supprimer le salaire ?")}
      onCloseModal={onClickClose}
      handleDelete={onDeleteClicked}
      isLoading={isLoading}
      colorBtn="green"
    />
  );
}

export default ModalDeleteSalary;
